import {NgModule} from '@angular/core';
import {
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDividerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatPaginatorModule, MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatTooltipModule,
    MatTreeModule
} from '@angular/material';
import {AgmCoreModule} from '@agm/core';
import {KeyValuePipe} from '@angular/common';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {AgGridModule} from 'ag-grid-angular';
import {NgImageSliderModule} from 'ng-image-slider';

import {FuseSharedModule} from '../@fuse/shared.module';

import {ApprovalPipe} from './config/approval-pipe';
import {BankAccountPipe} from './config/bank-account-pipe';
import {MonthPipe} from './config/month-pipe';
import {StringifyPipe} from './config/stringify-pipe';
import {TruncatePipe} from './config/truncate-pipe';
import {BooleanPipe} from './config/boolean-pipe';
import {RxApprovalPipe} from './config/rx-approval-pipe';
import {DayNamePipe} from './config/day-name-pipe';
import {NgxDaterangepickerMd} from 'ngx-daterangepicker-material';
import {TimeConversionPipe} from './config/time-conversion-pipe';
import {DurationPipe} from './config/duration';
import {PercentagePipe} from './config/percentage-pipe';
import {LeafletMarkerClusterModule} from '@asymmetrik/ngx-leaflet-markercluster';
import {LeafletModule} from '@asymmetrik/ngx-leaflet';
import {AmountConversionPipe} from './config/amount-conversion-pipe';

@NgModule({
    declarations: [TruncatePipe, StringifyPipe, ApprovalPipe, MonthPipe, BankAccountPipe, BooleanPipe, RxApprovalPipe,
        DayNamePipe, TimeConversionPipe, DurationPipe, PercentagePipe, AmountConversionPipe],
    imports: [
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatStepperModule,
        MatCheckboxModule,
        MatTreeModule,
        MatCardModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatExpansionModule,
        MatSlideToggleModule,
        MatDatepickerModule,
        MatDividerModule,
        MatGridListModule,
        MatMenuModule,
        MatButtonToggleModule,
        MatRadioModule,
        MatChipsModule,
        MatTooltipModule,
        MatProgressBarModule,

        AgmCoreModule,
        NgxMatSelectSearchModule,
        FuseSharedModule,
        AgGridModule,
        NgImageSliderModule,
        NgxDaterangepickerMd,
        LeafletModule,
        LeafletMarkerClusterModule
    ],
    exports: [
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatStepperModule,
        MatCheckboxModule,
        MatTreeModule,
        MatCardModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatExpansionModule,
        MatSlideToggleModule,
        MatDatepickerModule,
        MatDividerModule,
        MatGridListModule,
        MatMenuModule,
        MatButtonToggleModule,
        MatRadioModule,
        MatChipsModule,
        MatTooltipModule,
        MatProgressBarModule,
        LeafletModule,
        LeafletMarkerClusterModule,

        AgmCoreModule,
        NgxMatSelectSearchModule,
        FuseSharedModule,
        AgGridModule,
        NgImageSliderModule,
        NgxDaterangepickerMd,

        KeyValuePipe,
        TruncatePipe,
        StringifyPipe,
        ApprovalPipe,
        MonthPipe,
        BankAccountPipe,
        BooleanPipe,
        RxApprovalPipe,
        DayNamePipe,
        TimeConversionPipe,
        DurationPipe,
        PercentagePipe,
        AmountConversionPipe
    ],
    bootstrap: []
})
export class BizSharedModule {
}
